import { createModalContext } from '@landr/mfe';
import { InteractionSource } from 'utils/analytics/AnalyticsV2Service.generated';

export interface PaidDownloadUpsellModalData {
    interactionSource: InteractionSource;
}

export const {
    modalProvider: PaidDownloadUpsellModalProvider,
    modalContext: PaidDownloadUpsellModalContext,
    useModal: usePaidDownloadUpsellModal,
} = createModalContext<PaidDownloadUpsellModalData>();
